import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { ChangeEmployeeActivityPayload } from "../../payload/ChangeEmployeeActivity/ChangeEmployeeActivityPayload";

const changeEmployeeActivityFetch = (state: EmployeesState, action: PayloadAction<ChangeEmployeeActivityPayload>) => {
    state.isLoading = true;
}

export default changeEmployeeActivityFetch;